import { Session } from 'next-auth';
import { auth } from './auth.config';
import { signOut } from 'next-auth/react';

type UserInfo = {
    id: string;
    documentId: string;
    jwt: string;
};

/**
 * Helper function to access getServerSession without having the need to pass the authOptions config around the
 * application.
 *
 * This is a NextAuth recommendation specified here: https://next-auth.js.org/configuration/nextjs#getserversession
 */
function getAuthSession(): Promise<Session | null> {
    return auth();
}

export function getCurrentUserToken(): Promise<string | undefined> {
    return getAuthSession().then((session) => session?.user?.jwt);
}
export function getCurrentUserId(): Promise<string | undefined> {
    return getAuthSession().then((session) => session?.user?.id);
}

export function getCurrentUserInfo(): Promise<UserInfo | undefined> {
    return getAuthSession().then((session) => {
        const id = session?.user?.id;
        const jwt = session?.user?.jwt;
        const documentId = session?.user?.documentId;
        if (id === undefined || jwt === undefined || documentId === undefined) {
            return undefined;
        } else {
            return {
                id,
                documentId,
                jwt
            };
        }
    });
}

export function userSignOut() {
    return signOut();
}
